module.exports = __webpack_public_path__ + "img/icon-info.442aac62.svg";